//serves as a layer between components and the APIManager. 
//It provides a convenient way for components to make API requests by offering a clean and uniform API interface
//easily add more methods for other HTTP methods or customize the headers for specific requests.
import { API_ENDPOINT_LOGOUT } from "../Endpoints-API";
import { apiManagerGlobal } from "./Api-Manager";
import { ws_close_all } from "../websocket/Websocket-Middleware";
import { AUDIT_CLIENT_IP_KEY } from "../../utils/manualActionAudit";
import { readStoredVariantId } from "../../utils/sessionVariantId";
import { DIRECT_LOGIN_PROGRESS_KEY } from "../../utils/directLoginBootstrap";


import axios from "axios";

function withAuditSessionHeaders(headers = {}) {
    let next = { ...headers };
    const ip =
        typeof sessionStorage !== "undefined"
            ? sessionStorage.getItem(AUDIT_CLIENT_IP_KEY)
            : null;
    if (ip && /^\d{1,3}(\.\d{1,3}){3}$/.test(ip)) {
        next["X-Client-Public-IP"] = ip;
    }
    const variantId = readStoredVariantId();
    if (variantId) {
        next["X-Variant-Id"] = String(variantId).slice(0, 64);
    }
    return next;
}

function withVariantIdInUrl(endpoint) {
    const variantId = readStoredVariantId();
    if (!variantId || /[?&]variant_id=/.test(endpoint)) return endpoint;
    const sep = endpoint.includes("?") ? "&" : "?";
    return `${endpoint}${sep}variant_id=${encodeURIComponent(String(variantId).slice(0, 64))}`;
}

function withVariantIdInPayload(data) {
    const variantId = readStoredVariantId();
    if (!variantId || data == null) return data;
    const vid = String(variantId).slice(0, 64);
    if (typeof FormData !== "undefined" && data instanceof FormData) {
        if (!data.has("variant_id")) data.append("variant_id", vid);
        return data;
    }
    if (typeof data === "object" && !Array.isArray(data)) {
        if (data.variant_id != null && data.variant_id !== "") return data;
        return { ...data, variant_id: vid };
    }
    return data;
}

const APIMiddleware = {
    // Method to make a GET request
    get: (endpoint, headers = {}) => {
        headers.Authorization = localStorage.getItem("token");
        return apiManagerGlobal.request(withVariantIdInUrl(endpoint), "get", undefined, withAuditSessionHeaders(headers));
    },

    // Method to make a POST request
    post: (endpoint, data, headers = {}) => {
        headers.Authorization = localStorage.getItem("token");
        return apiManagerGlobal.request(endpoint, "post", withVariantIdInPayload(data), withAuditSessionHeaders(headers));
    },

    // Method to make a PUT request
    put: (endpoint, data, headers = {}) => {
        headers.Authorization = localStorage.getItem("token");
        return apiManagerGlobal.request(endpoint, "put", withVariantIdInPayload(data), withAuditSessionHeaders(headers));
    },

    // Method to make a DELETE request
    delete: (endpoint, headers = {}) => {
        headers.Authorization = localStorage.getItem("token");
        return apiManagerGlobal.request(withVariantIdInUrl(endpoint), "delete", undefined, withAuditSessionHeaders(headers));
    },
    // Method to make a POST request which includes form
    postForm: (endpoint, data, headers = {}) => {
        headers.Authorization = localStorage.getItem("token");
        return apiManagerGlobal.requestIncludesImage(endpoint, "post", withVariantIdInPayload(data), withAuditSessionHeaders(headers));
    },
};


// Add Axios interceptor for handling unauthorized errors globally
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        if (error.response && error.response.status == 401 || error.response && error.response.data.accessRight == 4)  {
            if (sessionStorage.getItem(DIRECT_LOGIN_PROGRESS_KEY) === '1') {
                return Promise.reject(error);
            }

            // Clear cookies and local storage
            // Make a request to logout endpoint
            const variantId=localStorage.variantId
            const userId=localStorage.userId
           const response= await APIMiddleware.get(API_ENDPOINT_LOGOUT(variantId,userId));
           if (response) {
            localStorage.removeItem("userId");
            localStorage.removeItem("token");
                await ws_close_all();
                if (variantId != undefined) {
                    localStorage.removeItem("variantId");
                      }
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
          
        }
        return Promise.reject(error);
    }
);
export default APIMiddleware;
